<template>
    <v-row no-gutters>
        <template>
            <v-card min-height="90vh" elevation="4" class="p-0">
                <v-card-title class="font-weight-normal p-2"
                    style="border-bottom: 1.5px solid #fbc02d;border-radius: 0;">Ikhtisar</v-card-title>
                
            </v-card>
        </template>
    </v-row>
</template>
<script>
export default {
    data: () => ({
    }),
}
</script>